import { Language } from '@yleisradio/areena-types';
import { getTranslation } from '../../client/localizations/translations';

export const getButtonText = (
  isGeoBlocked: boolean,
  text: string | undefined,
  language: Language,
  itemType: string | undefined
) => {
  if (isGeoBlocked) {
    return getTranslation('common_geoBlocked', language);
  }
  if (text) {
    return text;
  }
  if (itemType) {
    if (itemType.includes('TV')) {
      return getTranslation('common_play_tv', language);
    }
    if (itemType.includes('Radio')) {
      return getTranslation('common_play_radio', language);
    }

    if (itemType.includes('Collection')) {
      return getTranslation('common_play_package', language);
    }
  }

  return getTranslation('common_play_tv', language);
};
